/* unplugin-vue-components disabled */import script from "./ParamTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./ParamTable.vue?vue&type=script&lang=ts&setup=true"

import "./ParamTable.vue?vue&type=style&index=0&id=2ea46345&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ea46345"]])

export default __exports__